@if (connectedPartner.type=='MERCHANT') {
  <div class="row justify-content-end">
    <button class=" mt-3 col-md-2 ml-2 mr-2 col-lg-2 btn btn-warning mb-2 text-white">Solde total : {{realBalance}}</button>
    <div class="mt-3 rounded bg-success col-md-2 col-lg-2 mb-2 text-white"> Solde disponible : {{availableBalance}} </div>
  </div>
}
<div class="container">
  <div class="modal" tabindex="-1" role="dialog" id="createCashout" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body"><span
        class="{{this.messageColor}} text-center font-weight-bold">{{this.message}}</span></div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" tabindex="-1" role="dialog" id="detailsCashout">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header bg-success round">
          <h3 class="d-flex align-items-center text-white">Information de la demande</h3>
        </div>
        <div class="modal-body">
          <div><span class="fs-3">Date de la demande : </span><span
        class="fs-3 fw-bold">{{currentCashout?.createAt}}</span></div>
        <div><span class="fs-3">Montant: </span><span class="fs-2 fw-bold">{{currentCashout?.amount}}</span></div>
        <div><span class="fs-3">Moyen de reception <br /> </span><span
      class="fs-4 fw-bold">{{currentCashout?.receiptMean?.mode?.network}} : </span><span
    class="fs-3 fw-bold text-success">{{currentCashout?.receiptMean?.reference}}</span></div>
    <div><span class="fs-3">Date dernière modification : </span><span
  class="fs-2 fw-bold ">{{currentCashout?.modifiedAt}}</span></div>
  <div>@if (currentCashout?.status=='FAILED') {
    <span
    class="bg-danger round text-white">&Eacute;CHOU&Eacute;</span>
  }</div>
  <div>@if (currentCashout?.status=='PENDING') {
    <span class="bg-warning round text-white">EN ATTENTE DE
    VALIDATION</span>
  }</div>
  <div>@if (currentCashout?.status=='VALIDATED') {
    <span class="bg-success round text-white">EN ATTENTE DE
    PAIEMENT</span>
  }</div>
  <div>@if (currentCashout?.status=='PAID') {
    <span class="bg-success round text-white">SUCC&Eacute;S</span>
  }
</div>
<div>@if (currentCashout?.status=='CANCELED') {
  <span
  class="bg-secondary round text-white">ANNUL&Eacute;</span>
}</div>
</div>
</div>
</div>
</div>
@if (isCashout) {
  <div class="container d-flex justify-content-center align-items-center mt-3" id="createCashoutF"
    >
    <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;" (ngSubmit)="onSendCashout()"
      [formGroup]="cashoutForm">
      <div class="row d-flex justify-content-start">
        <button type="button" class="btn col-sm-2 btn-success" (click)="OnHistoryCashout()">Historique</button>
      </div>
      <h2 class="mb-4">Remboursement</h2>
      <div class="form-group form-floating">
        <input type="number" class="ml-2 mr-2 mt-2 form-control" id="amount" formControlName="amount"
          placeholder="Montant">
        <label for="amount">Montant</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="receptionNetwork" class="ml-2 mr-2 mt-2 form-select" id="receptionNetwork"
          (change)="onChangeReceiptMean()">
          <option vale=""> Choisir le type de moyen de reception</option>
          <option value="BANK_ACCOUNT">Compte bancaire</option>
          <option value="WVSN">Wave</option>
          <option value="OMSN">Orange money</option>
        </select>
        <label for="receptionNetwork">Choisir votre type de moyen de receiption</label>
      </div>
      <div class="form-group form-floating">
        <select class="ml-2 mr-2 mt-2 form-control" id="receptionMean" formControlName="receptionMean"
          placeholder="Moyen de reception">
          <option value=""> Choisir le moyen de reception</option>
          @for (recept of receiptionMeans; track recept) {
            <option value="{{recept.reference}}">{{recept.reference}}</option>
          }
        </select>
        @if (receptionNetwork =='BANK_ACCOUNT') {
          <label for="receptionMean">Choisir compte bancaire</label>
        }
        @if (receptionNetwork !='BANK_ACCOUNT') {
          <label for="receptionMean">Choisir numero telephone</label>
        }
      </div>
      <div>
        <input type="hidden" class="form-control mr-4" id="idPartner" formControlName="idPartner" name="idPartner">
      </div>
      <!--div align="end">
      <button type="button" class="btn btn-success mr-3 mt-1" (click)="onDisplayAddMean()">+Ajouter un moyen de remboursement</button>
    </div-->
    <button type="submit" class="btn btn-success btn-block mt-3"
    [disabled]="!this.cashoutForm.valid">Valider</button>
  </form>
</div>
}
@if (isAddReceiptMean) {
  <div class="container d-flex justify-content-center align-items-center mt-3" id="receiptMeanForm"
    >
    <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;"
      (ngSubmit)="onAddReceiptMean()" [formGroup]="receiptMeanForm">
      <h2 class="mb-4">Ajouter moyen de remboursement</h2>
      <div class="form-group form-floating">
        <input type="hidden" formControlName="idPartner" name="idPartner">
        <select formControlName="receptionNetwork" class="ml-2 mr-2 mt-2 form-select" id="receptionNetwork">
          <option vale=""> Choisir le type de moyen de reception</option>
          <option value="BANK_ACCOUNT">Compte bancaire</option>
          <option value="WVSN">Wave</option>
          <option value="OMSN">Orange money</option>
        </select>
        <label for="receptionNetwork">Choisir votre type de moyen de receiption</label>
      </div>
      <div class="form-group form-floating">
        <input class="ml-2 mr-2 mt-2 form-control" id="receptionMean" formControlName="receptionMean"
          placeholder="Moyen de reception">
        <label for="receptionMean">Choisir le moyen de reception</label>
      </div>
      <div>
        <input type="hidden" class="form-control mr-4" id="idPartner" formControlName="idPartner" name="idPartner">
      </div>
      <button type="submit" class="btn btn-success btn-block mt-3"
      [disabled]="!this.receiptMeanForm.valid">Valider</button>
    </form>
  </div>
}
@if (isListCashout) {
  <div class="container" id="receiptMeanForm">
    <div class="row d-flex justify-content-start">
      @if (connectedUser.role?.code=='ADMIN_SCHOOL'||connectedUser.role?.code=='ADMIN_MERCH') {
        <button type="button" class="btn col-sm-3 btn-success mb-2" (click)="onDisplayCashout()"
          >Faire une demande
        de fonds</button>
      }
      <div class="row d-flex fs-2 font-weight-bold justify-content-center"> Liste de demandes</div>
    </div>
    <table class="table table-bordered table-hover table-striped text-center">
      <thead class="table-success">
        <tr>
          @if (connectedPartner.canBeParent==true) {
            <th>Marchand</th>
          }
          <th>Date soumission</th>
          <th>Montant</th>
          <th>status</th>
          <th>Date traitement</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for (trx of cashouts?.content | paginate : pageConfig; track trx) {
          <tr>
            @if (connectedPartner.canBeParent==true) {
              <td>{{trx.receiptMean.partner.name}}</td>
            }
            <td>{{trx.createAt}}</td>
            <td>{{trx.amount}}</td>
            @if (trx.status=='FAILED') {
              <td class="bg-danger round text-white">&Eacute;CHOU&Eacute;</td>
            }
            @if (trx.status=='PENDING') {
              <td class="bg-warning round text-white">EN ATTENTE DE VALIDATION</td>
            }
            @if (trx.status=='VALIDATED') {
              <td class="bg-success round text-white">EN ATTENTE DE PAIEMENT</td>
            }
            @if (trx.status=='PAID') {
              <td class="bg-success round text-white">SUCC&Eacute;S</td>
            }
            @if (trx.status=='CANCELED') {
              <td class="bg-secondary round text-white">ANNUL&Eacute;</td>
            }
            <td>{{trx.modifiedAt}}</td>
            <td class="d-flex justify-content-between">
              @if (connectedUser.role?.code=='MERCHANT_CHECKER'&&trx.status=='PENDING') {
                <button type="button" class="btn btn-success mr-2 ml-2" (click)="onUpdateCashout(trx,'VALIDATED')"
                >Valider</button>
              }
              @if (connectedUser.role?.code=='MERCHANT_CHECKER'&&trx.status=='PENDING') {
                <button type="button" class="btn btn-danger mr-2" (click)="onUpdateCashout(trx,'CANCELED')"
                >Annuler</button>
              }
              @if ((connectedUser.role?.code=='SYS_ACCOUNTANT'||connectedUser.role?.code=='SCHOOLS_MANAGER')&&trx.status=='VALIDATED') {
                <button type="button" class="btn btn-success mr-2" (click)="onUpdateCashout(trx,'PAID')"
                >Payer</button>
              }
              <button type="button" class="btn btn-info" (click)="onDetailsCashout(trx)">Details</button>
            </td>
          </tr>
        }
      </tbody>
      <div class="d-flex justify-content-center">
        <pagination-controls previousLabel="Precedent" nextLabel="Suivant" (pageChange)="onNextPage($event)">
        </pagination-controls>
      </div>
    </table>
  </div>
}
</div>
